module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-72.203a5a81.svg";